import React from "react";
import LinearProgress from "@mui/joy/LinearProgress";
import styles from "./Loading.module.css";

const Loading = () => {
  return (
    <div className={styles.loading}>
      <LinearProgress determinate={false} variant="soft" />
    </div>
  );
};

export default Loading;
